var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeparator = function SvgSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 .5h11m46 0h11m46 0h11m46 0h11m45 0h11M20 .5h11m46 0h11m46 0h11m46 0h11M39 .5h11m46 0h11m46 0h11m46 0h11",
    stroke: "#032A3D",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  })));
};
export default SvgSeparator;